import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	color: var(--color-white-solid);
	pointer-events: none;
	row-gap: 4px;
`;

export const Flex = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	button {
		padding: 0 20px;
		margin: -20px -10px -20px 0;
		pointer-events: auto;
	}
`;

export const Level = styled.div`
	position: relative;
	z-index: 0;
	display: flex;
	width: 52px;
	height: 52px;
	border-radius: 100%;
	margin-right: 12px;
	background: linear-gradient(259.11deg, #e492f3 5.63%, #4e78ee 100.37%);
	box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
	&[data-smalltext='true'] {
		&::after {
			font-size: var(--font-size-4xl);
		}
	}
	&::after {
		display: inline-block;
		width: 46px;
		padding-right: 5px;
		border-radius: inherit;
		margin: auto;
		background: #322b52;
		color: var(--color-white-solid);
		content: attr(data-level);
		font-size: var(--font-size-5xl);
		font-weight: var(--font-weight-normal);
		letter-spacing: -4px;
		line-height: var(--line-height-display-m);
		text-align: center;
		white-space: nowrap;
	}
	&::before {
		position: absolute;
		z-index: -1;
		width: 100%;
		height: 100%;
		border: 3px solid transparent;
		border-radius: 100%;
		background: linear-gradient(259.11deg, #e492f3 5.63%, #4e78ee 100.37%);
		content: '';
		inset: 0;
		mask: linear-gradient(#ffffff 0 0) padding-box, linear-gradient(#ffffff 0 0);
		-webkit-mask-composite: destination-out;
		mask-composite: exclude;
		opacity: 0;
	}
`;

export const Neuron = styled.div`
	position: relative;
	z-index: 0;
	margin-right: 12px;
	&::after {
		position: absolute;
		z-index: -1;
		top: 8px;
		left: 8px;
		height: calc(100% - 16px);
		border-radius: 50%;
		aspect-ratio: 1 / 1;
		box-shadow: 0 0 0 0 var(--color-rose-58-solid);
		content: '';
	}
`;

export const Flame = styled.div`
	position: relative;
	margin-right: 12px;
`;
